
import Vue from 'vue'
import i18n from '@/locales/_i18n';

const getDefaultState = () => {
    return {
        user: {
          id: 0,
          nome: "",
          email: "",
        },

        menu: {
            reload: false,
            itemGrupoMenu: null
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async logout() {
      localStorage.clear();
      this.$router.push('/logout');
    },

    async Auth( { commit }, loginRequest) {

        try {
            const result = await Vue.prototype.$spTechApi.post("login/auth", loginRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let loginResponse = result.data;
                const idUsuario = loginResponse.idUsuario;

                localStorage.setItem("idUsuario", idUsuario);
                localStorage.setItem("token", loginResponse.token);
                Vue.prototype.getRoot.isAuthenticated = true;
                loginResponse = await actions.UserById({ commit }, idUsuario);

                return {
                    success: true,
                    message: i18n.t('logInCredencialValida'),
                    data: loginResponse
                };
            }
            else {
                return {
                    success: false,
                    message: i18n.t('logInCredencialInvalida'),
                    data: null
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: i18n.t('logInCredencialInvalida'),
                data: null
            };
        }
    },

    async UserById( { commit }, idUsuario) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`usuario/${idUsuario}/true`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let loginResponse = result.data;

                localStorage.setItem("idUsuario", loginResponse.id);
                Vue.prototype.getRoot.isAuthenticated = true;
                Vue.prototype.getRoot.userInfo = loginResponse;

                commit('saveState', loginResponse);

                return loginResponse;
            }
            else {
                return false
            }
        }
        catch(ex) {
            console.log("Erro ao validar usuário", ex);
            return false;
        }
    },

    async RecoveryPassword( _, requestRecovery) {

        try {
            const result = await Vue.prototype.$spTechApi.post("login/recovery-password", requestRecovery,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: i18n.t('recoverPasswordMessage3'),
                };
            }
            else {
                return {
                    success: false,
                    withApprove: false,
                    message: i18n.t('recoverPasswordMessage4')
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `${i18n.t('recoverPasswordMessage4')}: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `${i18n.t('recoverPasswordMessage4')}: [${error}]`
                };
            }
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.user, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.user;
    },

    menuState: state => {
        return state.menu;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
